import { helloWorld } from "./hello-world";

helloWorld("from boilerplate");
